
export function swDev (){
    let swUrl = `${process.env.PUBLIC_URL}/sw.js`
      if ('serviceWorker' in navigator) {
         console.log("Will the service worker register?");
         navigator.serviceWorker.register(swUrl)
           .then(function(reg){
             console.log("Yes, it did.");
          }).catch(function(err) {
             console.log("No it didn't. This happened:", err)
         });
      }
    
    }